<div class="col-sm-12 my-3 my-md-5">
    <div class="row">
        <div class="col-sm-6">
            <h2><span *ngIf="corporateLeadId">View</span><span *ngIf="!corporateLeadId">Add</span> Coroprate Lead</h2>
        </div>
        <div class="col-sm-6">
            <a routerLink="/corporate-lead-sheetview" class="ml-2 btn btn-success pull-right">
                <i class="fa fa-chevron-left" aria-hidden="true"></i> Back
            </a>
        </div>
    </div>
    <div class="card">
        <div class="row p-5">
                <div class="col-sm-8 border-right">
                    <form [formGroup]="CorporateLeadForm" (submit)="submitCorporateLead()">
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="form-label">Company Name*</label>
                                    <input type="text" formControlName="company_name" class="form-control"/>
                                    <div *ngIf="submitted && f.company_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.company_name.errors.required">Company Name is required</div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Client Name*</label>
                                    <input type="text" formControlName="client_name" class="form-control"/>
                                    <div *ngIf="submitted && f.client_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.client_name.errors.required">Client Name is required</div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Designation</label>
                                    <input type="text" formControlName="designation" class="form-control"/>
                                   
                                </div>
                                
                               
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                
                                <div class="col-sm-4">
                                    <label class="form-label">Company Email*</label>
                                    <input type="email" formControlName="company_email" class="form-control"/>
                                    <div *ngIf="submitted && f.company_email.errors" class="invalid-feedback">
                                        <div *ngIf="f.company_email.errors.required">Company Email is required</div>
                                        <div *ngIf="!f.company_email.valid && f.company_email.value">Company Email format is Invalid</div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Company Contact Number*</label>
                                    <input type="number" formControlName="company_contact_number" class="form-control"/>
                                    <div *ngIf="submitted && f.company_contact_number.errors" class="invalid-feedback">
                                        <div *ngIf="f.company_contact_number.errors.required">Company Contact Number is required</div>
                                        <div *ngIf="!f.company_contact_number.valid && f.company_contact_number.value">Invalid Company Contact number format</div>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Number of Employee</label>
                                    <input type="number" formControlName="number_of_employee" class="form-control"/>
                                </div>
                                
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="form-label">Circle*</label>
                                    <mat-select placeholder="Select Circle" formControlName="circle_id">
                                        <mat-option value="">Select Circle</mat-option>
                                        <mat-option [value]="circle.id" *ngFor="let circle of circles">{{circle.name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.circle_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.circle_id.errors.required">Circle is required</div>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <label class="form-label">Incorporate license</label>
                                    <mat-select placeholder="Select Incorporate license" formControlName="incorporate_licence">
                                        <mat-option value="">Select Incorporate license</mat-option>
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Cover type</label>
                                    <mat-select placeholder="Select Cover type" formControlName="cover_type">
                                        <mat-option value="">Select Cover type</mat-option>
                                        <mat-option [value]="1">E(Employee only)</mat-option>
                                        <mat-option [value]="2">ES(Employee + Spouse)</mat-option>
                                        <mat-option [value]="3">ESK (EMPLOYEE+SPOUSE+KIDS)</mat-option>
                                        <mat-option [value]="4">ESKP(EMPLOYEE+SPOUSE+KIDS+PARENTS)</mat-option>
                                    </mat-select>
                                   
                                </div>
                                
                            </div>
                        </div>
                        
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="form-label">Policy Type</label>
                                    <mat-select placeholder="Select Policy Type" formControlName="policy_type">
                                        <mat-option value="">Select Policy Type</mat-option>
                                        <mat-option [value]="1">Fresh</mat-option>
                                        <mat-option [value]="2">Renewal</mat-option>
                                    </mat-select>
                                   
                                </div>

                                <div class="col-sm-4">
                                    <label class="form-label">Sum insured looking for ?</label>
                                    <mat-select placeholder="Sum insured looking for ?" formControlName="sum_insured">
                                        <mat-option value="">Sum insured looking for</mat-option>
                                        <mat-option [value]="1">1-5 lakhs</mat-option>
                                        <mat-option [value]="2">5-10 lakhs</mat-option>
                                        <mat-option [value]="3">10-15 lakhs</mat-option>
                                        <mat-option [value]="4">15-20 lakhs</mat-option>
                                    </mat-select>
                                   
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Renewal Date</label>
                                    <mat-form-field appearance="fill">
                                        <mat-label>Choose a date</mat-label>
                                        <input matInput readonly formControlName="renew_date" [matDatepicker]="picker">
                                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                   
                                </div>
                                
                            </div>
                        </div> 
                        <div class="form-group">
                            <div class="row">
                                <div class="col-sm-4">
                                    <label class="form-label">Select User*</label>
                                    <mat-select placeholder="Select User" formControlName="user_id">
                                        <mat-option value="">Select User</mat-option>
                                        <mat-option [value]="user.id" *ngFor="let user of usersList">{{user.name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.user_id.errors" class="invalid-feedback">
                                        <div *ngIf="f.user_id.errors.required">User is required</div>
                                    </div>
                                   
                                </div>
                                <div class="col-sm-4">
                                    <label class="form-label">Status*</label>
                                    <mat-select placeholder="Select Status" formControlName="status">
                                        <mat-option value="">Select Status</mat-option>
                                        <mat-option [value]="status.id" *ngFor="let status of corporate_lead_status">{{status.status_name}}</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-label">Description</label>
                                    <textarea rows="5" formControlName="description" class="form-control"></textarea>
                                </div>
                            </div>
                        </div>              
                        
                        <div class="card-footer" *ngIf="!corporateLeadId">
                            <div class="col-sm-12">
                                <button type="submit" [disabled]="loading" class="btn btn-primary" ><i *ngIf="loading" class="fa fa-spin fa-spinner"></i> Submit</button>
                            </div>
                        </div> 
                    </form>
                </div>
                <div class="col-sm-4">
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12 text-danger">
                                <b><i>Required Fields:</i></b>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 bold">
                                Company Name <br />
                                Company Contact Number <br />
                                Company Email <br />
                                Client Name <br />
                                Circle <br />
                                Status<br />
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>
